import { generateMetricKey } from '@intelligence/v3/utils/metric';
import { DATASOURCE_KEY_MAP, MSCIENCE_METRIC_KEY_MAP } from './keyMap';

/**
 * MScience数据源Digital Revenue指标
 */
export const MSCIENCE_DIGITAL_REVENUE_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.MSCIENCE,
  metric: MSCIENCE_METRIC_KEY_MAP.DIGITAL_REVENUE,
});

/**
 * MScience数据源Digital Revenue指标环比
 */
export const MSCIENCE_DIGITAL_REVENUE_METRIC_RATIO_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.MSCIENCE,
  metric: MSCIENCE_METRIC_KEY_MAP.DIGITAL_REVENUE,
  ratio: true,
});

/**
 * MScience数据源Digital Units指标
 */
export const MSCIENCE_DIGITAL_UNITS_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.MSCIENCE,
  metric: MSCIENCE_METRIC_KEY_MAP.DIGITAL_UNITS,
});

/**
 * MScience数据源Digital Units指标环比
 */
export const MSCIENCE_DIGITAL_UNITS_METRIC_RATIO_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.MSCIENCE,
  metric: MSCIENCE_METRIC_KEY_MAP.DIGITAL_UNITS,
  ratio: true,
});
